import Image from 'next/image'
import DimOverlay from './DimOverlay'
import ExclamationCircleFillIcon from '@src/shared/icons/ExclamationCircleFillIcon'

type AlertImageType = keyof typeof alertImage

export interface AlertProps {
  onClose: () => void
  title: string
  description: string
  imgType?: AlertImageType
  confirmBtnText: string
  onConfirm: () => void
  renderCancelBtn?: boolean
}

const alertImage = {
  bonus: '/images/mobility-bonus/v1/bonus.png',
  credit: '/images/mobility-bonus/v1/credit.png',
  license: '/images/mobility-bonus/v1/license.png',
  passport: '/images/mobility-bonus/v1/passport.png',
}

const Alert = ({
  title,
  description,
  imgType,
  confirmBtnText,
  onConfirm,
  onClose,
  renderCancelBtn = true,
}: AlertProps) => {
  return (
    <DimOverlay onClose={onClose}>
      <div className="tw-rounded-radius-400 tw-mx-spacing-400 tw-z-[9999] tw-w-full tw-max-w-[382px] tw-overflow-hidden tw-bg-white">
        <div className="tw-p-spacing-600 tw-flex tw-w-full tw-flex-col tw-items-center">
          {imgType ? (
            <Image
              src={alertImage[imgType]}
              width={270}
              height={100}
              alt="alert img"
            />
          ) : (
            <ExclamationCircleFillIcon />
          )}
          <div className="tw-mt-spacing-400 tw-gap-spacing-150 tw-flex tw-flex-col tw-items-center">
            <p className="title2 tw-text-text-strong">{title}</p>
            <p className="body3 tw-text-gray-600 tw-break-words tw-break-keep tw-text-center">
              {description}
            </p>
          </div>
          <div className="tw-mt-spacing-800 tw-w-full">
            <button
              onClick={() => onConfirm()}
              className="tw-rounded-radius-350 tw-px-spacing-600 tw-py-spacing-400 tw-bg-blue-500 tw-w-full">
              <p className="title2 tw-text-white">{confirmBtnText}</p>
            </button>
            {renderCancelBtn && (
              <button onClick={onClose} className="tw-mt-spacing-250 tw-w-full">
                <p className="title4 tw-my-spacing-100 tw-text-gray-600">
                  닫기
                </p>
              </button>
            )}
          </div>
        </div>
      </div>
    </DimOverlay>
  )
}

export default Alert
